import { cleanupEmissionConsumptionMarkup, renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';
import { Text } from '@oneaudi/unified-web-components';
import { useAtom, useAtomValue } from 'jotai';
import { Fragment } from 'react';
import { ConsumptionAndEmissionTextStyle } from '~/app/compositions/content/consumption-and-emission-text/styles/consumption-emission-text-style';
import { useMarketConfig } from '~/app/market-config';
import { state } from '~/storage';

interface Props {
	containerClass?: string;
}

export const ConsumptionAndEmissionText = ({ containerClass }: Props) => {
	const { config } = useMarketConfig();
	const [isLandscape] = useAtom(state.isLandscape);
	const currentView = useAtomValue(state.currentView);
	const consumptionDisclaimersConfiguredCar = useAtom(state.consumptionDisclaimersConfiguredCarAtom);
	const consumptionDisclaimer = useAtom(state.consumptionDisclaimersAtom);

	const [consumptionDisclaimers] =
		currentView === 'summary' ? consumptionDisclaimersConfiguredCar : consumptionDisclaimer;

	if (!config.showCaESummaryText) {
		return <ConsumptionAndEmissionTextStyle className={containerClass} />;
	}

	return (
		<ConsumptionAndEmissionTextStyle className={containerClass}>
			<label className={`text-wrapper ${isLandscape ? 'is-landscape' : ''}`}>
				{consumptionDisclaimers &&
					consumptionDisclaimers.length > 0 &&
					consumptionDisclaimers.map((disclaimer, index) => {
						return (
							<Fragment key={disclaimer}>
								<label className="entry-wrapper" key={index}>
									<Text tag="span" variant={{ type: 'copy', order: '2', style: 'normal' }}>
										{renderTextWithFootnotesReferencesV2(
											cleanupEmissionConsumptionMarkup(disclaimer?.toString() ?? ''),
										)}
									</Text>
								</label>
								{index < consumptionDisclaimers.length - 1 && (
									<Text tag="span" variant={{ type: 'copy', order: '2', style: 'normal' }}>
										{' | '}
									</Text>
								)}
							</Fragment>
						);
					})}
			</label>
		</ConsumptionAndEmissionTextStyle>
	);
};
